module.exports = __webpack_public_path__ + "img/sejong_gallery0.116d8941.jpg";